/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetModifierGroups200ResponseItemsInner } from './GetModifierGroups200ResponseItemsInner';
import {
    GetModifierGroups200ResponseItemsInnerFromJSON,
    GetModifierGroups200ResponseItemsInnerFromJSONTyped,
    GetModifierGroups200ResponseItemsInnerToJSON,
    GetModifierGroups200ResponseItemsInnerToJSONTyped,
} from './GetModifierGroups200ResponseItemsInner';

/**
 * 
 * @export
 * @interface GetModifierGroups200Response
 */
export interface GetModifierGroups200Response {
    /**
     * 
     * @type {Array<GetModifierGroups200ResponseItemsInner>}
     * @memberof GetModifierGroups200Response
     */
    items: Array<GetModifierGroups200ResponseItemsInner>;
    /**
     * 
     * @type {number}
     * @memberof GetModifierGroups200Response
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetModifierGroups200Response
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof GetModifierGroups200Response
     */
    itemsPerPage: number;
}

/**
 * Check if a given object implements the GetModifierGroups200Response interface.
 */
export function instanceOfGetModifierGroups200Response(value: object): value is GetModifierGroups200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('itemsPerPage' in value) || value['itemsPerPage'] === undefined) return false;
    return true;
}

export function GetModifierGroups200ResponseFromJSON(json: any): GetModifierGroups200Response {
    return GetModifierGroups200ResponseFromJSONTyped(json, false);
}

export function GetModifierGroups200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetModifierGroups200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetModifierGroups200ResponseItemsInnerFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'itemsPerPage': json['itemsPerPage'],
    };
}

export function GetModifierGroups200ResponseToJSON(json: any): GetModifierGroups200Response {
    return GetModifierGroups200ResponseToJSONTyped(json, false);
}

export function GetModifierGroups200ResponseToJSONTyped(value?: GetModifierGroups200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(GetModifierGroups200ResponseItemsInnerToJSON)),
        'total': value['total'],
        'page': value['page'],
        'itemsPerPage': value['itemsPerPage'],
    };
}

